import { useCallback, useState } from "react";

// center initial node to ancestral node
export const useToppedTree = (defaultTranslate = { x: 0, y: 0 }) => {
  const [translate, setTranslate] = useState(defaultTranslate);
  const containerRef = useCallback((containerElem) => {
    if (containerElem !== null) {
      const { width, height } = containerElem.getBoundingClientRect();
      setTranslate({ x: width / 2, y: 150 });
    }
  }, []);
  return [translate, containerRef];
};
